import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "questionCircleFilled"
const QuestionCircleFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M12 1.5C17.799 1.5 22.5 6.201 22.5 12S17.799 22.5 12 22.5 1.5 17.799 1.5 12 6.201 1.5 12 1.5M12 15.375C11.379 15.375 10.875 15.879 10.875 16.5S11.379 17.625 12 17.625 13.125 17.121 13.125 16.5 12.621 15.375 12 15.375M12.695 6.255C12.005 6.119 11.288 6.19 10.637 6.46S9.43 7.185 9.038 7.77 8.438 9.046 8.438 9.75H10.312C10.313 9.416 10.413 9.09 10.598 8.813 10.782 8.535 11.046 8.318 11.354 8.19 11.662 8.063 12.002 8.03 12.329 8.095S12.957 8.32 13.193 8.557 13.59 9.094 13.655 9.42 13.687 10.088 13.56 10.396C13.432 10.704 13.215 10.968 12.938 11.153 12.66 11.34 12.334 11.438 12 11.438H11.813C11.398 11.438 11.063 11.774 11.063 12.188V14.438H12.937V13.184C13.307 13.084 13.659 12.926 13.98 12.712 14.565 12.32 15.022 11.764 15.292 11.113 15.56 10.463 15.631 9.746 15.494 9.055 15.357 8.364 15.017 7.729 14.52 7.23S13.386 6.393 12.695 6.256"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default QuestionCircleFilledIcon
